import { getRegionsByColumns } from './getRegionsByColumns';
import { getSpecialMainCities } from './getSpecialMainCities';
import { SPECIAL_REGIONS } from '../../../../constants/geo';
import { IRegion } from '../../../../types/regions';

interface IGetCitiesByAlphabetResult {
  mainCities: IRegion[];
  citiesByColumns: IRegion[][][];
}

export function getCitiesStepData(
  allRegions: IRegion[],
  currentRegion: IRegion,
  regionsById: Map<number, IRegion>,
): IGetCitiesByAlphabetResult {
  const parentRegionId = currentRegion.parentId || currentRegion.id;
  const specialRegionIds = SPECIAL_REGIONS.map(region => region.id);
  const cities = allRegions.filter(city => city.parentId === parentRegionId && !specialRegionIds.includes(city.id));

  const mainCities: IRegion[] = [];
  const letters: string[] = [];
  const citiesByAlphabet: Record<string, IRegion[]> = {};

  cities.forEach(city => {
    const { name } = city;
    const parentRegion = city.parentId ? regionsById.get(city.parentId) : null;

    if (parentRegion && parentRegion.mainTownId === city.id) {
      mainCities.push(parentRegion);
      mainCities.push(city);
    } else {
      if (!citiesByAlphabet[name[0]]) {
        citiesByAlphabet[name[0]] = [];
        letters.push(name[0]);
      }

      citiesByAlphabet[name[0]].push(city);
    }
  });

  letters.sort();

  const citiesByColumns = getRegionsByColumns(letters, citiesByAlphabet, cities.length - mainCities.length);

  const specialMainCities = getSpecialMainCities(currentRegion, regionsById);

  return {
    mainCities: specialMainCities || mainCities,
    citiesByColumns,
  };
}
